/*
 *
 * ComparativeAnalysis constants
 *
 */

export const GET_HEADERS_SUCCESS = "app/ComparativeAnalysis/GET_HEADERS_SUCCESS"

export const GET_FILTERS_WATCHER = "app/ComparativeAnalysis/GET_FILTERS_WATCHER"
export const GET_FILTERS_SUCCESS = "app/ComparativeAnalysis/GET_FILTERS_SUCCESS"

export const GET_DIVISIONS_WATCHER =
  "app/ComparativeAnalysis/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS =
  "app/ComparativeAnalysis/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED =
  "app/ComparativeAnalysis/GET_DIVISIONS_FAILED"

export const GET_DIVISIONS_CHILDS_WATCHER =
  "app/ComparativeAnalysis/GET_DIVISIONS_CHILDS_WATCHER"

export const GET_DIVISIONS_ROWS_WATCHER =
  "app/ComparativeAnalysis/GET_DIVISIONS_ROWS_WATCHER"
export const GET_DIVISIONS_ROWS_SUCCESS =
  "app/ComparativeAnalysis/GET_DIVISIONS_ROWS_SUCCESS"

export const GET_INDICATOR_WATCHER =
  "app/ComparativeAnalysis/GET_INDICATOR_WATCHER"
export const GET_INDICATOR_SUCCESS =
  "app/ComparativeAnalysis/GET_INDICATOR_SUCCESS"
export const GET_INDICATOR_FAILED =
  "app/ComparativeAnalysis/GET_INDICATOR_FAILED"

export const GET_MEASURE_WATCHER = "app/ComparativeAnalysis/GET_MEASURE_WATCHER"
export const GET_MEASURE_SUCCESS = "app/ComparativeAnalysis/GET_MEASURE_SUCCESS"
export const GET_MEASURE_FAILED = "app/ComparativeAnalysis/GET_MEASURE_FAILED"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/ComparativeAnalysis/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/ComparativeAnalysis/GET_MEASURE_COLOR_RANGE_SUCCESS"

export const GET_MEASURE_INFO_SEGMENT_WATCHER =
  "app/ComparativeAnalysis/GET_MEASURE_SEGMENT_WATCHER"
export const GET_MEASURE_INFO_SEGMENT_FAILED =
  "app/ComparativeAnalysis/GET_MEASURE_SEGMENT_FAILED"
export const GET_MEASURE_INFO_SEGMENT_SUCCESS =
  "app/ComparativeAnalysis/GET_MEASURE_SEGMENT_SUCCESS"
